import React from "react";

// Libs
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux"
import store from "reducers/store"

// Contexts
import { ToastProvider } from "~/contexts/ToastContext";
import { UnsavedChangesProvider } from "~/contexts/UnsavedChangesContext";
import { ThemeProvider } from "~/contexts/ThemeContext";

// Routes
import { Public } from "~/routes/routes";

// Importa os ícones do Font Awesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { faTwitter, faFontAwesome } from '@fortawesome/free-brands-svg-icons'

// Adiciona os ícones ao library
library.add(fas, faTwitter, faFontAwesome)

// Styles
import "~/styles/App.css"

// Exporta a store para ser usada em outros arquivos
export const myStore = store

export const App = () => {
	return (
		<div className="App">
			<Provider store={myStore}>
				<ThemeProvider>
					<UnsavedChangesProvider>
						<ToastProvider>
							<BrowserRouter>
								<Public />
							</BrowserRouter>
						</ToastProvider>
					</UnsavedChangesProvider>
				</ThemeProvider>
			</Provider>
		</div>
	);
}
